import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createShop,
  deleteShopById,
  fetchShops,
  updateShop,
} from "../../redux/slices";
import Toast from "../../Hooks/useToast";

const useShopController = () => {
  const dispatch = useDispatch();
  const { list, loading, saving, deleting } = useSelector(
    (state) => state.shop
  );

  useEffect(() => {
    dispatch(fetchShops());
  }, [dispatch]);

  const refetchShops = useCallback(() => {
    dispatch(fetchShops());
  }, [dispatch]);

  const handleCreateShop = async (payload) => {
    try {
      await dispatch(createShop(payload)).unwrap();
      Toast("Shop saved successfully", "success");
      dispatch(fetchShops());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to add shop";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleUpdateShop = async (id, payload) => {
    try {
      await dispatch(updateShop({ id, ...payload })).unwrap();
      Toast("Shop updated successfully", "success");
      dispatch(fetchShops());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to update shop";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleDeleteShop = async (id) => {
    try {
      await dispatch(deleteShopById(id)).unwrap();
      Toast("Shop deleted successfully", "success");
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to delete shop";
      Toast(msg, "error");
      throw err;
    }
  };

  return {
    values: {
      list,
      loading,
      saving,
      deleting,
    },
    functions: {
      handleCreateShop,
      handleUpdateShop,
      handleDeleteShop,
      refetchShops,
    },
  };
};

export default useShopController;
